import { $insertNodes, TextNode, LexicalEditor } from 'lexical';

export const insertTextToEditor = (editor: LexicalEditor, text: string) => {
  editor.update(() => {
    const lastNode = new TextNode(text);
    $insertNodes([lastNode]);
  });
  editor.focus();
};
